import { Fragment, Suspense } from "react";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import Property from "./Property";
import { Finder2 as Finder } from "../../../../../../modules/finder";
import * as UI from "../../../../../../modules/ui-kit";
import ParameterFinderPlugin from "../../entities/parameter/ParameterFinderPlugin";


const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;

    .separator {
        border: none;
        border-bottom: 1px solid #4441;
        width: 100%;

        &:last-of-type {
            display: none;
        }
    }
`;

interface IProperty {
    parameter: string
    value: boolean | number | string
    unit?: string
}

interface IPropertiesProps {
    disabled?: boolean
    // Kept in `value` so a save preserves them, but neither listed nor addable here.
    lockedParameterIDs?: string[]
    onChange: (properties: IProperty[]) => void
    value: IProperty[]
}

export default function Properties(props: IPropertiesProps) {
    const { disabled, lockedParameterIDs = [], onChange, value } = props;

    const [Dialog, open, close] = useDialog();

    function update(property, propertyUpdate) {
        /*
        Add property
         */
        if (!property && propertyUpdate) {
            onChange([...value, propertyUpdate]);
            return;
        }

        /*
        Remove property
         */
        if (property && !propertyUpdate) {
            onChange(
                value.toSpliced(
                    value.indexOf(property),
                    1,
                )
            );
            return;
        }

        /*
        Change property
         */
        onChange(
            value.with(
                value.indexOf(property),
                {
                    ...property,
                    ...propertyUpdate,
                },
            )
        );
    }

    function add(parameterID, unit) {
        update(
            undefined,
            {
                parameter: {
                    id: parameterID,
                },
                __id: crypto.randomUUID(),
                unit,
            },
        );
        close();
    }

    return (
        <Styled>
            {
                value
                    .map((property) => property.parameter.id)
                    .filter((e, i, a) => a.indexOf(e) === i)
                    .filter((parameterID) => !lockedParameterIDs.includes(parameterID))
                    .map(
                        (parameterID) => (
                            <Fragment key={ parameterID }>
                                <Suspense>
                                    <Property
                                        disabled={ disabled }
                                        parameterID={ parameterID }
                                        properties={ value.filter((property) => property.parameter.id === parameterID) }
                                        onChange={ update }
                                    />
                                </Suspense>
                                <hr className="separator" />
                            </Fragment>
                        )
                    )
            }
            <UI.Button
                disabled={ disabled }
                onClick={ open }
            >
                Add property
            </UI.Button>
            <Dialog>
                <Finder placeholder="Search for a Parameter">
                    <ParameterFinderPlugin
                        disabledParameters={ [...(value ?? []).map((property) => property.parameter?.id), ...lockedParameterIDs] }
                        onSelect={ add }
                    />
                </Finder>
            </Dialog>
        </Styled>
    );
}
